import { Component, OnInit, Input, ViewChild, OnDestroy, ElementRef } from '@angular/core';
import { StageSandbox } from '../../services/stage.sandbox';
import { Router } from '@angular/router';

import * as stageTypes from '../../types';
import * as animations from '../../../shared/animations';
import * as commonTypes from '../../../shared/types';
import * as _ from 'lodash';
import { QUESTION_TYPES } from '../../types/constants';

import { Subscription, Observable } from 'rxjs/Rx';

@Component({
  selector: 'tr-sub-login-container',
  templateUrl: './sub-login-container.component.html',
  //styleUrls: ['./sub-login-container.component.scss']
})
export class SubLoginContainerComponent implements OnInit {
  @Input() entity: stageTypes.IPage;
  private subscriptions: Array<Subscription> = [];
  private currentAction: string = '';
  private blockContainers: stageTypes.IContainerDef[] = [];
  private currentStageId$: Observable<number> = this.sb.getCurrentStageId$();

  constructor(private sb: StageSandbox, private router: Router) { }

  ngOnInit() {
    this.blockContainers = [].concat(this.sb.groupElements(this.entity));
  }

  isDownloading$(questionId: string): Observable<boolean> {
    return this.sb.getFileDownloadingStatus$(questionId, this.currentAction);
  }

  currentAction$(): Observable<string> {
    return Observable.of(this.currentAction);
  }

  onElementAction(actionName: string, question: stageTypes.IHtmlElement) {
    this.currentAction = actionName.toLowerCase();
    this.subscriptions.push(
      this.sb.onDocumentAction(actionName, question.id)
    );
  }

  viewedDocumentStatus$(questionId: number): Observable<boolean> {
    return this.sb.getFileReadingStatus$(questionId);
  }

  getFileContent$(questionId: number): Observable<any> {
    return this.sb.getFileContent$(questionId);
  }

  onUpdatePassword(e: Event) {
    this.router.navigate(['/authentication/updatePassword']);
  }

}



// WEBPACK FOOTER //
// ./src/app/stage/containers/sub-login-container/sub-login-container.component.ts